import React, { useCallback } from 'react';
import {
  DocumentFieldsCRUDMeta,
  DocumentFieldUpdatePayload,
} from 'Interfaces/DocumentFields';
import { fontFamilyByValue } from 'Services/Fonts';

import FontFamilySelect from '../FontFamilySelect';

interface FieldStyleSelectorsProps {
  fontFamily: string | null | undefined;
  onUpdateDocumentField: (
    payload: Omit<DocumentFieldUpdatePayload, 'id'>,
    meta?: DocumentFieldsCRUDMeta,
  ) => void;
}

function FieldStyleSelectors({
  fontFamily,
  onUpdateDocumentField,
}: FieldStyleSelectorsProps) {
  const handleChangeFontFamily = useCallback(
    (fontFamily: string | null | undefined) => {
      if (!fontFamily) return;
      onUpdateDocumentField({
        fontFamily,
        style: {
          fontFamily: fontFamilyByValue[fontFamily],
        },
      });
    },
    [onUpdateDocumentField],
  );

  return (
    <div className="fieldDropDown__styles">
      <p className="fieldDropDown__styles-title">Styles</p>
      <div className="fieldDropDown__styles-select">
        <p className="fieldDropDown__styles-label">Font Family</p>
        <FontFamilySelect value={fontFamily || ''} onSelect={handleChangeFontFamily} />
      </div>
    </div>
  );
}

export default FieldStyleSelectors;
